import { call, put, select, takeLatest, fork } from 'redux-saga/effects';

import {
  fetchCountriesSuccess,
  fetchCountriesFailure,
  FETCH_COUNTRIES_REQUEST,
} from '../actions/fetchCountriesActions';
import { fetchCurrenciesSuccess } from '../actions/fetchCurrenciesActions';
import CountriesAPI from '../api/CountriesAPI';
import { sortAlphabetically } from '../lib/sorting';
import { accessTokenSelector } from '../reducers/selectors';

import { manageAPIError } from './helpers/errorHelper';

const uniq = countries => {
  const result = [];

  countries.forEach(country => {
    const { value } = country;

    if (result.find(c => c.value === value) === undefined) {
      result.push(country);
    }
  });

  return result;
};

const prepareCountriesPayloadFor = payload =>
  payload.map(({ alpha3, name, currency }) => {
    const { isoCode = '' } = currency || {};

    return {
      value: alpha3,
      label: name,
      currency: isoCode,
    };
  });

const prepareCurrenciesPayloadFor = payload => {
  const currenciesPayload = payload
    .filter(({ currency }) => currency !== null)
    .map(({ currency }) => {
      const { isoCode: value, symbol } = currency;

      return { value, label: value, symbol };
    });

  return sortAlphabetically(uniq(currenciesPayload), 'label');
};

function* countriesWatcher() {
  yield takeLatest(FETCH_COUNTRIES_REQUEST, countriesWorker);
}

function* countriesWorker(action) {
  try {
    const accessToken = yield select(accessTokenSelector);
    const payload = yield call(CountriesAPI.getCountries, accessToken);
    const countriesPayload = yield call(prepareCountriesPayloadFor, payload);
    yield put(fetchCountriesSuccess(countriesPayload));
    const currenciesPayload = yield call(prepareCurrenciesPayloadFor, payload);
    yield put(fetchCurrenciesSuccess(currenciesPayload));
  } catch (error) {
    yield put(fetchCountriesFailure(error));
    yield fork(manageAPIError, { ...error, action, useFallbackError: false });
  }
}

export { countriesWorker, prepareCountriesPayloadFor, prepareCurrenciesPayloadFor };
export default countriesWatcher;
